export function videoHighlightSwiper() {
    const swiperContainers = document.querySelectorAll('.video-slider-swiper');
    
    if (!swiperContainers.length || typeof Swiper === 'undefined') {
        return;
    }

    swiperContainers.forEach((swiperContainer) => {
        const prevButton = swiperContainer.querySelector('.video-slider__arrow--prev');
        const nextButton = swiperContainer.querySelector('.video-slider__arrow--next');
        const slides = swiperContainer.querySelectorAll('.swiper-slide');
        const slideCount = slides.length;
        
        // Check if slides are less than 3
        const shouldDisable = slideCount <= 3;
        
        // Add slider-disabled class if slides are less than or equal to 3
        if (slideCount <= 3) {
            swiperContainer.classList.add('slider-disabled');
        }
        if (slideCount <= 2) {
            swiperContainer.classList.add('slider-gradient-disabled');
        }
        
        // Function to check if mobile (below 767px)
        const isMobile = () => window.innerWidth < 767;
        
        // Function to check if swiper should be initialized
        const shouldInitializeSwiper = () => {
            // Initialize if: slides > 3 OR on mobile (below 767px)
            return slideCount > 3 || isMobile();
        };
        
        // Function to get swiper config based on current state
        const getSwiperConfig = () => {
            const mobile = isMobile();
            
            return {
                slidesPerView: mobile ? 1 : 3,
                slidesPerGroup: 1,
                spaceBetween: 20,
                loop: true,
                speed: 2000,
                centeredSlides: true,
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: false,
                },
                navigation: {
                    nextEl: nextButton,
                    prevEl: prevButton,
                },
                allowTouchMove: true,
                breakpoints: {
                    991: {
                        slidesPerView: 'auto',
                        slidesPerGroup: 1,
                        spaceBetween: 20,
                    },
                    767: {
                        slidesPerView: 2,
                        slidesPerGroup: 1,
                        spaceBetween: 20,
                    },
                    460: {
                        slidesPerView: 1,
                        slidesPerGroup: 1,
                        spaceBetween: 20,
                    }
                }
            };
        };
        
        // Initialize or destroy swiper based on conditions
        let swiperInstance = null;
        
        const initOrDestroySwiper = () => {
            if (shouldInitializeSwiper()) {
                // Initialize swiper if not already initialized
                if (!swiperInstance) {
                    swiperInstance = new Swiper(swiperContainer, getSwiperConfig());
                }
            } else {
                // Destroy swiper if slides <= 3 and on desktop
                if (swiperInstance) {
                    swiperInstance.destroy(true, true);
                    swiperInstance = null;
                }
            }
        };
        
        // Initial initialization
        initOrDestroySwiper();
        
        // Handle resize to update swiper behavior
        let resizeTimeout;
        window.addEventListener('resize', () => {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(() => {
                initOrDestroySwiper();
            }, 150);
        });
    });


}



